import Component from './Slider.vue';

export default Component;
